/**
 * Internal user exclusion utilities.
 *
 * Rules are fetched from the `excluded_users` table via useExclusionRules().
 * This module provides the matching logic used by hooks and components.
 *
 * @module config/excluded-users
 */

import type { ExclusionRules } from '../hooks/useExcludedUsers';

/**
 * Check whether an email should be excluded from dashboard counts.
 *
 * @param email - The email to check
 * @param rules - Exclusion rules from useExclusionRules(). If omitted, no users are excluded.
 */
export function isExcludedUser(
  email: string | null | undefined,
  rules?: ExclusionRules,
): boolean {
  if (!email || !rules) return false;
  const normalized = email.toLowerCase().trim();
  if (rules.emails.some((e) => normalized === e)) return true;
  const domain = normalized.split('@')[1];
  if (domain && rules.domains.some((d) => domain === d)) return true;
  return false;
}
